export enum GameState {
    LOADING,
    PLAYING,
    LOST,
}